import script from "./HighScoresView.vue?vue&type=script&setup=true&lang=js"
export * from "./HighScoresView.vue?vue&type=script&setup=true&lang=js"

import "./HighScoresView.vue?vue&type=style&index=0&id=577fc279&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577fc279"]])

export default __exports__